import React, { forwardRef, useState } from 'react';
import './PasswordField.css';

type PasswordFieldProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  inputClassName?: string;
};

const PasswordField = forwardRef<HTMLInputElement, PasswordFieldProps>(
  ({ inputClassName = '', className = '', disabled, id, ...props }, ref) => {
    const [visible, setVisible] = useState(false);

    return (
      <div className={`password-field ${className}`.trim()}>
        <input
          ref={ref}
          id={id}
          type={visible ? 'text' : 'password'}
          className={`password-field-input ${inputClassName}`.trim()}
          disabled={disabled}
          {...props}
        />
        <button
          type="button"
          className="password-field-toggle"
          onClick={() => setVisible((v) => !v)}
          disabled={disabled}
          aria-label={visible ? 'Hide password' : 'Show password'}
          aria-pressed={visible}
          tabIndex={-1}
        >
          <i className={`fa ${visible ? 'fa-eye-slash' : 'fa-eye'}`} aria-hidden="true" />
        </button>
      </div>
    );
  }
);

PasswordField.displayName = 'PasswordField';

export default PasswordField;
